module.exports = {
    tag: 'resilience',
    quality: 0.6,
    toughness: 1,
    regeneration: 0.6,
    physicalResil: 1,
    mentalResil: 1
};